module.exports = __webpack_public_path__ + "img/good-session-7.3e9a92e1.png";